import { render, staticRenderFns } from "./SupplierInquiryPage.vue?vue&type=template&id=191a61d0&scoped=true"
import script from "./SupplierInquiryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupplierInquiryPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SupplierInquiryPage.vue?vue&type=style&index=0&id=191a61d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a61d0",
  null
  
)

export default component.exports